module.exports = __webpack_public_path__ + "static/media/learn_more_3.59d913fc.png";